export default __webpack_public_path__ + "static/industry-poster-6d6c1a203511073a7f9a0872c7d51115.jpg";